import React from 'react'
import { DataGrid,GridToolbarQuickFilter } from "@mui/x-data-grid";
import { Box } from '@mui/material';
import { useSelector,useDispatch } from 'react-redux';
import { toggleTrack,setLoading } from '../Redux/TrackSlice';
import { ColorButton } from './AdminTable'
import "./TrackTable.css"

const TrackTable = ({setOpenAdd}) => {

  function CustomToolbar() {
    return (
      <Box
      sx={{        
        margin: '-56px -8px 0', // Pull the toolbar out of the DataGrid's top and side borders
        padding: '8px 12px',        
        display: 'flex',
        justifyContent: 'space-between',       
      }}
    >
        <GridToolbarQuickFilter
        placeholder="Search by Track or lead here..."
          sx={{
            width: 300, // Adjust the width
            // height: 30, // Adjust the height
            '& .MuiInputBase-root': {
              fontSize: '1rem', // Adjust font size
            },
          }}
        />
        <ColorButton
                    variant="contained"
                    className="cancel-button"
                    size="small"                        
                    onClick={()=>setOpenAdd(true)}
                    sx={{
                      "background-color": "white",
                      "color": "black",
                      "border": "2px solid blueviolet",
                      "border-radius": "18px",
                      "text-transform": "capitalize",
                      "padding": "5px 29px",
                      "font-weight": "600",
                      "font-size": "14px",                                
                    }}
                  >
                    Add Track
                </ColorButton>
      </Box>
    );
  }

  const {data,loading,error}= useSelector((state)=>state.track);
  const dispatch= useDispatch();

  if(loading){
    return <h2>Loading...</h2>
  }
  else if(error){
    return <h2>Error occured in getting track data</h2>
  }
  const rows= data?.map((track)=>({
    id:track.id,
    track_title:track.title,
    lead: track.lead,
    isActive: track.isActive
  }));

  const handletoggleIsActive=(e,trackId)=>{
    let newisActiveval= e.target.checked;
    dispatch(setLoading(true));
    dispatch(toggleTrack({newisActiveval,trackId}));
  }

  const columns=[{
    field: 'serialNumber', 
    align: 'center',
    headerName: <div >SI#</div>, 
    width: 75, 
    renderCell: (params) => params.api.getSortedRowIds().indexOf(params.id) + 1,
  },{ field: 'track_title',
    headerName: <div>Track</div>,
    width: 425 },
    {field: 'lead',
    headerName: <div>Lead</div>,
    width: 300 },
  //   {
  //     field: "isActive",
  //     align: 'center',
  //     headerName: <div>Is Active</div>,
  //     minWidth: 105, sortable: true, flex: 1, 
  //     renderCell: (params) => <div>                
  //         <input type="checkbox" name="Requestor" checked={(params.row.isActive ? true : false)} 
  //             onChange={(e) => handletoggleIsActive(e,params.row.id)} />                 
  //     </div>                                            
  // },
  ];

  return (
    
       <Box sx={{ height: 400,marginTop:"40px"}}>
      <DataGrid
        rows={rows}
        columns={columns}
        autoHeight={true}
        initialState={{pagination: {paginationModel: { page: 0, pageSize: 6 },},}}
        disableSelectionOnClick
        disableSelection
        sx={{border: '1px solid #e0e0e0',
          overflow:"visible !important",
          '& .MuiDataGrid-toolbarContainer': {
            margin: '0px', // Pull the toolbar slightly out of the DataGrid border
            padding: '0px',
          },
          "& .MuiDataGrid-columnHeader": {
            backgroundColor: "#022278", // Customize the header background color
            color: "white", // Customize text color
          },
          "& .MuiDataGrid-root": {
            width: "100%", // Ensure DataGrid spans the full width
          },
          "& .MuiDataGrid-sortIcon": {
            color: "#fff", // Customize the sorter (sort icon) color
          },
          "& .MuiDataGrid-columnHeader": {
            position: "sticky",
            top: 0,
            backgroundColor: "#022278", // Optional: to ensure it’s visible on scroll
            color: "#fff",
          },
          "& .MuiDataGrid-columnHeaders": {
            width: "var(--DataGrid-rowWidth)",
          },
          "& .MuiDataGrid-row": {
            backgroundColor: "white",
            width: "calc(100% - 2px)",
          },
          "& ..MuiDataGrid-topContainer": {
            width: "700px !important",
          },
        }}
        slots={{ toolbar: CustomToolbar }}
      />
        </Box>
  )
}

export default TrackTable